// import { mapGetters } from 'vuex';
export const dateMixin = {
  data() {
    return {
      days: [
        // { id: '2022-07-22', date: '2022-07-21T22:00:00.000Z' }
      ],

      dates: [],
      attrs: [
        {
          dates: new Date(),
          highlight: 'red',
        },
      ],
    };
  },
  computed: {
    selectedDates() {
      return this.days.map((day) => day.date);
    },
    attributes() {
      const selected = this.selectedDates.map((date) => ({
        highlight: true,
        dates: date,
      }));

      const today = [{
        dates: new Date(),
        highlight: 'red',
      }];
       
      return [...selected, ...today];
    },
    getMinDate() {
      const today = new Date();

      const noDateInThePast = this.dates.every((d) => {
        //console.log('check date:', d, today);
        if (d >= today) return true;
        return false;
      });

      //console.log('getMinDate:', this.dates, noDateInThePast);
      if (noDateInThePast) return new Date();
      return null;
    },
    getTodayDate() {
      const today = new Date();
      return today;
    },
  },
  methods: {

  },
};
